// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageTitle_wrapper__Yc_MV","wrapperPlain":"PageTitle_wrapperPlain__9HjIB","titleHeader":"PageTitle_titleHeader__zd5uK"};